import {IntermediatePart} from "../../intermediatePart";

export default class Table extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'table';
    this.partName = 'Table';
    this.translateId = "visualizer.bathroom.shower.table";
    this.canBeDisabled = true;
  }

}
